import { useState } from 'react';
import { completeLeadAction } from '../../../services/api';
import { Loader2 } from 'lucide-react';

export const CompleteActionModal = ({ isOpen, onClose, lead, onRefresh }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [data, setData] = useState({ description: '', next_date: '', status: '', price: '' });
  if (!isOpen) return null;
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (data.status === 'won' && Number(data.price) <= 0) {
      setError('Укажите сумму закрытой сделки в тенге.');
      return;
    }
    setLoading(true);
    setError('');
    try { 
      await completeLeadAction(lead.id, {
        ...data,
        price: data.status === 'won' ? Number(data.price) : null,
      });
      onRefresh(); 
      onClose(); 
      setData({ description: '', next_date: '', status: '', price: '' });
    } 
    catch (err) {
      setError(err.response?.data?.errors?.price?.[0] || err.response?.data?.message || 'Не удалось сохранить результат');
    } finally { setLoading(false); }
  };
  return (
    <div className="fixed inset-0 z-[120] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/80 backdrop-blur-xl" onClick={onClose} />
      <div className="relative bg-[#1e293b] border border-white/10 w-full max-w-md rounded-[2.5rem] p-8 shadow-2xl">
        <h3 className="text-xl font-black text-white tracking-tight uppercase text-center mb-6">Результат касания</h3>
        <form onSubmit={handleSubmit} className="space-y-5">
          <textarea required value={data.description} onChange={e => setData({...data, description: e.target.value})} className="w-full bg-slate-900/50 border border-white/5 rounded-2xl p-4 text-sm text-slate-200 focus:ring-2 focus:ring-indigo-500 focus:outline-none min-h-[100px]" placeholder="О чем договорились?..." />
          <div className="grid grid-cols-2 gap-4">
            <input type="date" value={data.next_date} onChange={e => setData({...data, next_date: e.target.value})} className="w-full bg-slate-900/50 border border-white/5 rounded-xl p-3 text-xs font-bold text-white color-scheme-dark" />
            <select value={data.status} onChange={e => setData({...data, status: e.target.value})} className="w-full bg-slate-900/50 border border-white/5 rounded-xl p-3 text-xs font-bold text-white appearance-none">
              <option value="">Статус: Без изм.</option>
              <option value="new">Новый</option>
              <option value="processing">В работе</option>
              <option value="rejected">Отказ</option>
              <option value="won">Успешно</option>
            </select>
          </div>
          {data.status === 'won' && (
            <div>
              <label className="text-[10px] font-black text-emerald-400 uppercase tracking-widest ml-2 mb-2 block">Сумма закрытой сделки (₸)</label>
              <input
                autoFocus
                required
                type="number"
                min="1"
                step="1"
                value={data.price}
                onChange={e => setData({...data, price: e.target.value})}
                className="w-full bg-slate-900/50 border border-emerald-500/30 rounded-xl p-3 text-sm font-bold text-white focus:ring-2 focus:ring-emerald-500 focus:outline-none"
                placeholder="Например: 150 000"
              />
            </div>
          )}
          {error && <p className="text-xs font-bold text-rose-400">{error}</p>}
          <button disabled={loading} className="w-full bg-indigo-600 hover:bg-indigo-500 text-white py-4 rounded-2xl font-black text-xs uppercase tracking-widest transition-all">
            {loading ? <Loader2 className="animate-spin mx-auto" size={16} /> : 'СОХРАНИТЬ'}
          </button>
        </form>
      </div>
    </div>
  );
};
